var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_280_3531)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 24.5C40.1433 24.5 36.3731 25.6437 33.1664 27.7863C29.9596 29.929 27.4603 32.9745 25.9843 36.5377C24.5084 40.1008 24.1223 44.0216 24.8747 47.8043C25.6271 51.5869 27.4843 55.0615 30.2114 57.7886C32.9385 60.5157 36.4131 62.3729 40.1957 63.1253C43.9784 63.8777 47.8992 63.4916 51.4623 62.0156C55.0255 60.5397 58.071 58.0404 60.2136 54.8336C62.3563 51.6269 63.5 47.8567 63.5 44C63.4945 38.83 61.4383 33.8732 57.7825 30.2174C54.1268 26.5617 49.17 24.5055 44 24.5ZM44 53C42.22 53 40.4799 52.4722 38.9999 51.4832C37.5198 50.4943 36.3663 49.0887 35.6851 47.4442C35.0039 45.7996 34.8257 43.99 35.1729 42.2442C35.5202 40.4984 36.3774 38.8947 37.636 37.636C38.8947 36.3774 40.4984 35.5202 42.2442 35.1729C43.99 34.8257 45.7996 35.0039 47.4441 35.6851C49.0887 36.3663 50.4943 37.5198 51.4832 38.9999C52.4722 40.4799 53 42.22 53 44C52.9975 46.3862 52.0485 48.6739 50.3612 50.3612C48.6739 52.0485 46.3862 52.9975 44 53ZM51.3519 34.5256C49.6566 33.2005 47.6347 32.3583 45.5 32.0881V27.5694C48.8287 27.8692 51.9868 29.1775 54.5525 31.3194L51.3519 34.5256ZM42.5 32.0975C40.3653 32.3677 38.3434 33.2099 36.6481 34.535L33.4475 31.325C36.0132 29.1831 39.1712 27.8749 42.5 27.575V32.0975ZM34.5256 36.6481C33.2005 38.3434 32.3583 40.3653 32.0881 42.5H27.5694C27.8692 39.1712 29.1775 36.0132 31.3194 33.4475L34.5256 36.6481ZM32.0975 45.5C32.3677 47.6347 33.2099 49.6566 34.535 51.3519L31.325 54.5525C29.1831 51.9868 27.8749 48.8288 27.575 45.5H32.0975ZM36.6481 53.4744C38.3444 54.7961 40.3663 55.635 42.5 55.9025V60.4306C39.1712 60.1308 36.0132 58.8225 33.4475 56.6806L36.6481 53.4744ZM45.5 55.9025C47.6337 55.635 49.6556 54.7961 51.3519 53.4744L54.5525 56.675C51.9868 58.8169 48.8287 60.1251 45.5 60.425V55.9025ZM53.4744 51.3519C54.7961 49.6556 55.635 47.6337 55.9025 45.5H60.4306C60.1308 48.8288 58.8225 51.9868 56.6806 54.5525L53.4744 51.3519ZM55.9025 42.5C55.635 40.3663 54.7961 38.3444 53.4744 36.6481L56.675 33.4475C58.8169 36.0132 60.1251 39.1712 60.425 42.5H55.9025Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_3531",
    x1: 0,
    y1: 45.5,
    x2: 90,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2);
export default __webpack_public_path__ + "static/media/d-2.f41e7aba321bf2f11faefdaa13f4d2fa.svg";
export { ForwardRef as ReactComponent };